import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/landing/Navbar";
import Calculator from "@/components/landing/Calculator";
import { Toaster } from "@/components/ui/sonner";

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="bg-[#0A0D14] text-slate-50 min-h-screen overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <Calculator />
      <Toaster position="bottom-center" theme="dark" />
      <footer className="border-t border-white/10 py-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500">
            <div className="flex items-baseline gap-1">
              <span className="font-serif-display text-base font-bold text-slate-300">ECH</span>
              <span className="text-[9px] uppercase tracking-[0.25em] text-emerald-400 font-semibold">IDR</span>
            </div>
            <p data-testid="footer-copyright">© 2026 ECH IDR.</p>
          </div>
          <div className="mt-8 pt-6 border-t border-white/5 space-y-2 text-[11px] leading-relaxed text-slate-600 max-w-4xl" data-testid="footer-disclaimers">
            <p>
              All figures produced by this calculator are illustrative estimates only and do not constitute a guarantee,
              projection, or promise of recovery, reimbursement, or financial performance of any kind.
            </p>
            <p>
              Win-rate assumptions are drawn from publicly published CMS federal IDR data and Georgetown CHIR analyses
              and reflect industry-wide averages, not the performance of any specific provider, practice, or service.
              Actual outcomes vary by payer, claim eligibility, specialty, geography, filing quality, and timing.
            </p>
            <p>
              Nothing on this page constitutes legal, financial, billing, or medical advice. Federal IDR eligibility
              under the No Surprises Act is subject to strict deadlines and requirements — consult your own legal and
              billing professionals before relying on any estimate shown here.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
